const home = r => require.ensure([], () => r(require('@/views/HomeView.vue'), 'home'))

// 路由组件注册
const router = [
  {
    path: '/',
    name: 'home',
    component: home
  }
]

export default router
